import { useState, useEffect } from 'react';
import Form from './Form';
import axios from 'axios';

const host = 'https://www.planview.com'
const hostname = 'https://marketing.planview.com/'
const session = new Date().getTime()
const source = 'flowframework'

function appendScript(baseUrl, setScriptLoaded) {
    if (window.MktoForms2) return setScriptLoaded(true)
  
    const script = document.createElement("script")
    script.src = `${baseUrl}/js/forms2/js/forms2.min.js`
    script.onload = () => (window.MktoForms2 ? setScriptLoaded(true) : null)
    document.body.appendChild(script)
}

export default function MarketoForm({ baseUrl, munchkinId, formId, handleForm }) {
    const [scriptLoaded, setScriptLoaded] = useState(false)
    const [mktoFormReady, setMktoFormReady] = useState(false)
    const [formSubmit, setFormSubmit] = useState(false)
    const [formFields, setFormFields] = useState({})

    useEffect(() => {
      // console.log(window.location.href)
      if (scriptLoaded) {
        window.MktoForms2.loadForm(baseUrl, munchkinId, formId, function(mktoForm) {
          window.thisMktoForm = mktoForm 
        })
        window.MktoForms2.whenReady(() => setMktoFormReady(true))
        return
      }
      appendScript(baseUrl, setScriptLoaded)
    }, [scriptLoaded, baseUrl, munchkinId, formId])

    const getFormFields = (theFields) => {
      setFormFields(theFields)
    }

    useEffect(() => {
      if (formSubmit) {
        let payloadData = handleForm()
        payloadData = {
          TasktopMaturityData: payloadData.results,
          session,
          host,
          source,
          level: payloadData.level
        }

        formFields['Survey_Name_Admin_Only'] = 'FFC Tasktop Maturity'
        formFields['Survey_Results_Link_Admin_Only'] = 'https://www.planview.com/lps/surveys/admin/session/tasktop-maturity/'+session
        window.thisMktoForm.addHiddenFields(formFields)
        
        var x = document.querySelector('#mktoForm_3501 button.mktoButton');
        x.click()
        
        setFormSubmit(false)
        
        window.thisMktoForm.onSuccess(function(values, followUpUrl) {
          payloadData['person'] = values.Email
          axios.post(hostname + 'api/tasktop-maturity', {
            action: 'save',
            payload: payloadData
          }).then( function(res) {
            window.location.href += 'result.html?level=' + payloadData.level
          }).catch(err => {
            console.error(err)
          })
          return false
        })
      }
      return () => {
        setFormSubmit(false)
      }
    }, [formSubmit, formFields, handleForm])

  return (
    <div>
      <form id={`mktoForm_${formId}`} style={{ display: 'none' }}></form>
      {mktoFormReady ? <Form handleForm={handleForm} isFormSubmit={() => setFormSubmit(true)} isFieldChange={getFormFields} /> : <h1>Loading!</h1>}
    </div>
  )
}